import React from "react";

const SocialLoginProviders = () => {
  return (
    <div className="socialaccount_ballot">
      <ul className="list-group list-group-flush">
        <li className="list-group-item">
          <a href="/api/auth/google" className="btn btn-danger w-100">Login with Google</a>
        </li>
        <li className="list-group-item">
          <a href="/api/auth/facebook" className="btn btn-primary w-100">Login with Facebook</a>
        </li>
      </ul>
    </div>
  );
};

export default SocialLoginProviders;